module.exports = __webpack_public_path__ + "img/patio-art.94865c1b.jpg";